import { getCSRFToken } from '../utils/getCSRFToken';

export default function registerCartStore() {
  Alpine.store('cartStore', {
    editModeBooking: null,
    bookingItemsCount: 0,
    currentPath: window.location.pathname,
    bookingUrl: '',
    calendarUrl: '/calendar/',

    bookingCartUrl() {
      const bookingId = this.editModeBooking?.id;
      if (
        this.currentPath === this.calendarUrl &&
        this.editModeBooking &&
        bookingId
      ) {
        return `/fullbooking/${bookingId}`;
      } else {
        return this.calendarUrl;
      }
    },

    async toggleEditMode(open, selectorId, bookingId, options = {}) {
      const { suppressUiUpdate = false } = options;
      const bookingEditId = open ? bookingId : '';
      const url = '/calendar/update_edit_mode/'; // Ensure this matches your URL pattern
      const payload = {
        booking_edit_id: bookingEditId,
      };
      const hasNumericSelectorId =
        selectorId !== undefined &&
        selectorId !== null &&
        /^\d+$/.test(String(selectorId));

      // Some callers pass calendar UUIDs here; backend selector_id must be numeric.
      if (hasNumericSelectorId) {
        payload.selector_id = selectorId;
      }

      try {
        const response = await fetch(url, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'X-CSRFToken': getCSRFToken(),
          },
          body: JSON.stringify(payload),
        });

        const data = await response.json();
        if (!response.ok) {
          console.error(
            data.message || 'An error occurred while updating edit mode',
          );
          return { success: false, message: data.message };
        }

        if (data.status === 'success') {
          if (!suppressUiUpdate) {
            this.editModeBooking = data.edit_mode_booking;
            this.bookingItemsCount = data.edit_mode_booking
              ? data.edit_mode_booking.bookingitem_count
              : 0;
          }
          return { success: true, data };
        } else {
          console.error(data.message);
          return { success: false, message: data.message };
        }
      } catch (error) {
        console.error('Failed to toggle edit mode:', error);
        return {
          success: false,
          message: 'Failed to update booking edit mode',
        };
      }
    },

    async openBookingForItem(selectorId, bookingId) {
      if (!bookingId) {
        return;
      }

      const toastStore = Alpine.store('toastStore');
      const currentBookingId = this.editModeBooking?.id;
      const switchingBooking =
        currentBookingId && String(currentBookingId) !== String(bookingId);

      if (switchingBooking) {
        const closeResult = await this.toggleEditMode(false, selectorId, null, {
          suppressUiUpdate: true,
        });
        if (!closeResult?.success) {
          if (toastStore?.addToast) {
            toastStore.addToast(
              closeResult?.message || 'Could not switch bookings',
              'danger',
            );
          }
          return;
        }
      }

      if (!currentBookingId || switchingBooking) {
        const openResult = await this.toggleEditMode(
          true,
          selectorId,
          bookingId,
        );
        if (openResult?.success) {
          if (toastStore?.addToast) {
            toastStore.addToast(
              switchingBooking
                ? 'Switched booking in edit mode'
                : 'Booking opened in edit mode',
              'success',
            );
          }
        } else {
          // Close succeeded but open failed; keep UI in sync with backend.
          if (switchingBooking) {
            this.editModeBooking = null;
            this.bookingItemsCount = 0;
          }
          if (toastStore?.addToast) {
            toastStore.addToast(
              openResult?.message || 'Could not open booking',
              'danger',
            );
          }
        }
      }
    },

    async stopEditing() {
      const url = '/calendar/update_edit_mode/';

      try {
        const response = await fetch(url, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'X-CSRFToken': getCSRFToken(),
          },
          body: JSON.stringify({
            booking_edit_id: '',
          }),
        });

        const data = await response.json();
        if (data.status === 'success') {
          this.editModeBooking = null;
          this.bookingItemsCount = 0;
          // Reload calendar data to reflect changes
          if (Alpine.store('calendarStore')) {
            Alpine.store('calendarStore').fetchGridData();
            Alpine.store('calendarStore').fetchItemsData();
          }
        } else {
          console.error(data.message);
        }
      } catch (error) {
        console.error('Failed to stop editing:', error);
      }
    },

    checkEditMode() {
      const fields = ['first_name', 'last_name', 'email', 'phone_number'];
      const formSelectors = ['#addAccommodationForm', '#addTourForm'];

      if (this.editModeBooking) {
        fields.forEach((fieldName) => {
          const value = this.editModeBooking.main_guest[fieldName] || '';
          formSelectors.forEach((formSelector) => {
            document
              .querySelectorAll(`${formSelector} [name="${fieldName}"]`)
              .forEach((field) => {
                field.value = value;
                field.readOnly = true;
                field.classList.add('read-only-field');
              });
          });
        });
      } else {
        fields.forEach((fieldName) => {
          formSelectors.forEach((formSelector) => {
            document
              .querySelectorAll(`${formSelector} [name="${fieldName}"]`)
              .forEach((field) => {
                field.value = '';
                field.readOnly = false;
                field.classList.remove('read-only-field');
              });
          });
        });
      }
    },
    guestTooltip() {
      if (this.editModeBooking) {
        return `${this.editModeBooking.main_guest.first_name} ${this.editModeBooking.main_guest.last_name}`;
      }
      return '';
    },
    isCalendarPage() {
      console.log('this.currentPath:', this.currentPath);
      console.log('this.calendarUrl:', this.calendarUrl);
      return this.currentPath === this.calendarUrl;
    },
    animateCart() {
      // Select the cart element
      const cartElement = document.querySelector('.shopping-cart');
      if (cartElement) {
        // Add the animation class
        cartElement.classList.add('cart-animate');

        // Remove the animation class after animation ends
        setTimeout(() => {
          cartElement.classList.remove('cart-animate');
        }, 400); // Duration should match the animation duration in CSS
      }
    },
  });
}
